import styled, { css } from 'styled-components';

export const StrollerEachGeneralItem = styled.div`
  padding: ${(props) => (props.hideMargin ? '0' : '20px 0')};
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  margin: ${(props) => (props.hideMargin ? '0' : '16px 0 10px')};
  .vd {
    width: 100%;
    border: 1px solid #fff0;
    @media (min-width: 768px) {
      padding-left: 20px;
    }
  }
  h2 {
    color: #000;
    font-size: clamp(24px, 3vw, 32px);
    font-weight: 500;
    padding: 10px 20px;
  }
  .title {
    font-size: clamp(14px, 3vw, 16px);
    font-weight: bold;
    padding: 0 20px;
    margin: 8px 0;
  }
  .description {
    font-size: clamp(14px, 3vw, 16px);
    padding: 0 20px;
    @media (min-width: 768px) {
      line-height: 25px;
    }
  }
  .categories {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
    padding: 0 20px;

    .category_name {
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      opacity: 0.87;
      line-height: 18px;
      margin-top: 8px;
    }
    .category_image {
      padding-top: 100%;
      position: relative;
      img {
        background-image: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
    }
    @media (min-width: 768px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  .gifs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    .gif_image {
      padding-top: 125%;
      position: relative;
    }
    @media (min-width: 768px) {
      padding-left: 20px;
    }
  }
`;

export const CustomImageDiv = styled.div`
  padding-top: ${(props) => (props.video ? '0' : 100 / (props.ar || 1))}%;
  background: ${(props) =>
    props.widget
      ? 'unset'
      : `url("https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp") center center no-repeat`};
  background-size: cover;
  &.desktopWidget {
    @media (min-width: 768px) {
      width: 85%;
      padding-top: 85%;
      margin: auto;
      border-radius: 50%;
    }
    &:after {
      content: '';
      width: 100%;
      display: block;
      height: 100%;
      background: linear-gradient(137deg, #393e4c 0%, #6b9bd0 100%);
      position: absolute;
      inset: 0;
      z-index: 1;
      transition: opacity 500ms linear;
      opacity: ${(props) => (props.itemId === 2631 ? 1 : 0)};
      @media (min-width: 768px) {
        border-radius: 50%;
      }
    }
    &:before {
      content: '';
      width: 100%;
      display: block;
      height: 100%;
      background: radial-gradient(
        100.25% 100.25% at 48.71% -0.25%,
        #898989 12.62%,
        #464646 80.92%
      );
      position: absolute;
      inset: 0;
      z-index: 1;
      transition: opacity 500ms linear;
      opacity: ${(props) => (props.itemId === 2632 ? 1 : 0)};
      @media (min-width: 768px) {
        border-radius: 50%;
      }
    }
  }
  position: relative;
  video {
    width: 100%;
    display: block;
  }
  ${(props) =>
    props.gradient &&
    css`
      img {
        &.imageTrigger1 {
          left: 0px !important;
        }
        &.imageTrigger2 {
          left: 100% !important;
          transform: scale(0);
          opacity: 0;
        }
        transition: all 500ms linear !important;
        &.slideRight {
          left: 0 !important;
          transform: scale(1);
          opacity: 1;
        }
        &.slideLeftDisappear {
          left: -200% !important;
          transform: scale(0);
          opacity: 0;
        }
        &.slideRightDisappear {
          left: 100% !important;
          transform: scale(0);
          opacity: 0;
        }
        &.noTransition {
          transition: none;
        }
      }
    `}
`;

export const StrollerProductContainer = styled.div`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  .product_price {
    display: flex;
    column-gap: 10px;
  }
  .price {
    font-weight: bold;
  }
  .strikePrice {
    text-decoration: line-through;
    opacity: 0.4;
  }
  .discount {
    opacity: 0.4;
  }
  .inclusive {
    opacity: 0.4;
    font-size: 10px;
  }
  @media (min-width: 768px) {
    display: none;
  }
`;

export const StrollerWidgetStyle = styled.div`
  position: relative;
  flex-basis: 40%;
  span {
    overflow: visible !important ;
  }
`;

export const StrollerHeight = styled.div`
  width: 100%;
  border-radius: 50px;
  background-color: white;
  position: absolute;
  top: 90%;
  height: 20%;
  @media (min-width: 768px) {
    display: none;
  }
  z-index: 4;
`;

export const StrollerContent = styled.div`
  z-index: 3;
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  .tag_name {
    color: #b7b1b1;
    font-size: 13px;
    letter-spacing: 5px;
    font-weight: 400;
    display: flex;
    justify-content: flex-start;
    padding: 10px 20px;
  }
  .product_name {
    color: #000;
    font-size: clamp(18px, 3vw, 20px);
    font-weight: 500;
    padding: 12px 20px 10px;
  }
  .product_price {
    display: flex;
    column-gap: 10px;
    padding: 0 20px;
    .price {
      font-weight: bold;
    }
    .strikePrice {
      text-decoration: line-through;
      opacity: 0.4;
    }
    .discount {
      font-size: 14px;
      opacity: 0.4;
    }
  }
  .inclusive {
    font-size: 10px;
    opacity: 0.4;
    padding: 0 20px;
  }
  @media (min-width: 768px) {
    margin-top: 10px;
  }
`;

export const StrollerVarients = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 40px;
  @media (min-width: 768px) {
    justify-content: flex-start;
    padding: 0 20px;
  }

  margin-bottom: 30px;
`;

export const VairentColorStyle = styled.div`
  height: 38px;
  width: 38px;
  border-radius: 50%;
  background-color: ${(props) => props.bgColor};
  ${(props) =>
    props.selected &&
    css`
      outline-offset: 2px;
      outline: 1px solid black;
    `}
`;

export const VarientColorSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  align-items: center;
  padding-top: 20px;
  font-size: 13px;
  font-weight: 500;
  @media (min-width: 768px) {
    cursor: pointer;
  }
`;

export const BuyNowBlackButton = styled.div`
  display: ${(props) => (props.showOnDesktop ? 'none' : 'flex')};
  @media (min-width: 768px) {
    width: 100%;
    display: ${(props) => (props.showOnDesktop ? 'flex' : 'none')};
    margin: ${(props) => (props.showOnDesktop ? '24px auto 0' : '16px 0 0')};
  }
  align-items: center;
  justify-content: center;
  outline: none;
  border-radius: 4px;
  border: 1px solid #ef4e5e;
  background: #ef4e5e;
  color: white;
  text-align: center;
  width: 95%;
  height: 45px;
  line-height: 44px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  margin: ${(props) => (props.noMargin ? '0 auto' : '16px auto 0')};
  position: relative;
  text-transform: uppercase;
  overflow: hidden;
  @media (min-width: 720px) {
    cursor: ${(props) => (props.sizePopupButtons ? 'default' : 'pointer')};
  }

  transition: background 0.15s ease-in-out;

  span {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    background: linear-gradient(
      105deg,
      #ef4e5e,
      rgba(255 255 255) 14%,
      #ef4e5e 28%
    );

    width: 120%;
    height: 100%;
    animation: move_continue 2s;
    animation-iteration-count: infinite;
    animation-delay: 1s;
  }

  @keyframes move_continue {
    0% {
      left: 0;
      opacity: 0;
    }
    5% {
      opacity: 0;
    }
    48% {
      opacity: 0.2;
    }
    80% {
      opacity: 0;
    }
    100% {
      left: 82%;
    }
  }
`;

export const StrollerContentStyle = styled.div`
  flex-basis: 50%;
  overflow-x: hidden;
`;

export const TagData = styled.div`
  display: flex;
  font-size: 12px;
  flex-direction: column;
  margin: 60px 0 60px;
  span {
    margin: auto !important;
  }
  a {
    @media (max-width: 768px) {
      cursor: default;
    }
    text-decoration: underline;
  }
  .tagName {
    color: #000;
    text-align: center;
    font-size: 13px;
    font-weight: 500;
    margin: 20px 0 12px;
  }
  .tagLine {
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    max-width: 60%;
    margin: auto;
  }
`;

export const PartitionSpan = styled.div`
  height: 8px;
  display: block;
  margin-top: 30px;
  width: 100%;
  background: #d9d9d96b;
  @media (min-width: 768px) {
    display: none;
  }
`;

export const TagContainer = styled.div`
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-evenly;
    margin-top: 20px;
  }
`;

export const StrollerTopContainer = styled.div`
  @media (min-width: 720px) {
    display: flex;
    max-width: 80%;
    margin: auto;
    column-gap: 29px;
  }
`;
export const FertilityOfferContainer = styled.div`
  padding-top: 12px;
`;
export const FertilityOfferHead = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  margin: 6px 12px 12px;
  @media (min-width: 720px) {
    margin: 6px 0 12px;
  }
`;
export const OfferContainer = styled.div`
  width: ${(props) => (props.isFertilityProduct ? '' : '95%')};
  margin: ${(props) =>
    props.isFertilityProduct ? '10px 12px' : '40px auto 20px'};
  @media (min-width: 720px) {
    width: ${(props) => (props.isFertilityProduct ? '70%' : '65%')};
    margin: ${(props) => (props.isFertilityProduct ? '10px 0' : '20px')};
  }
  border: 1.5px solid #dadada;
  border-style: dashed;
  border-radius: 8px;
  position: relative;
  padding: ${(props) => (props.isFertilityProduct ? '12px' : '20px 8px 10px')};
  .offerDetails {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: ${(props) => (props.isFertilityProduct ? '0px' : '10px')};
  }

  ${(props) =>
    !props.isFertilityProduct
      ? css`
          &:after {
            content: '';
            width: 26px;
            height: 26px;
            background: #fff;
            border-radius: 50%;
            position: absolute;
            top: 50px;
            right: -13px;
            border: 1px solid #dadada;
            border-left: 1px solid #dadada;
            rotate: -45deg;
            border-right: 1px solid #fff;
            border-bottom: 1px solid #fff;
          }
          &:before {
            content: '';
            width: 26px;
            height: 26px;
            background: #fff;
            border-radius: 50%;
            position: absolute;
            top: 50px;
            left: -13px;
            border: 1px solid #dadada;
            border-left: 1px solid #dadada;
            rotate: 135deg;
            border-right: 1px solid #fff;
            border-bottom: 1px solid #fff;
          }
        `
      : null}

  &.lowOpacity {
    opacity: 0.4;
  }
  @media (min-width: 768px) {
    cursor: pointer;
  }
`;
export const OfferInfo = styled.div`
  flex-basis: 66%;
  p {
    color: #000;
    font-family: Montserrat;
    font-size: ${(props) => (props.isFertilityProduct ? '14px' : '13px')};
    font-weight: ${(props) => (props.isFertilityProduct ? '600' : '500')};
    line-height: ${(props) => (props.isFertilityProduct ? '1.36' : '')};
    .free {
      color: #d3484f;
      font-size: ${(props) => (props.isFertilityProduct ? '14px' : '13px')};
      font-weight: ${(props) => (props.isFertilityProduct ? '600' : '500')};
    }
  }
  span {
    color: rgba(0, 0, 0, 0.6);
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 400;
  }

  .facts {
    display: flex;
    gap: 10px;
    margin: 15px 7px;
  }

  .factText {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.8);
  }
`;
export const ProductImg = styled.div`
  padding-top: 38%;
  flex-basis: 42%;
  position: relative;
  img {
    object-fit: contain;
  }
`;
export const OfferTag = styled.div`
  position: absolute;
  top: 0;
  border-radius: 0px 0px 4px 0px;
  background: linear-gradient(
    273deg,
    rgba(252, 78, 88, 0.7) 0%,
    rgba(175, 19, 26, 0.7) 100%
  );
  overflow: hidden;
  color: #fff;
  font-size: 10px;
  font-weight: 400;
  left: 0;
  padding: 6px;
  font-family: 'Montserrat';
  span {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    background: linear-gradient(
      105deg,
      #ef4e5e,
      rgba(255 255 255) 14%,
      #ef4e5e 28%
    );
    width: 70%;
    height: 100%;
    animation: move_continue 2s;
    animation-iteration-count: infinite;
    animation-delay: 1s;
  }

  @keyframes move_continue {
    0% {
      left: 0;
      opacity: 0;
    }
    5% {
      opacity: 0;
    }
    48% {
      opacity: 0.2;
    }
    80% {
      opacity: 0;
    }
    100% {
      left: 82%;
    }
  }
`;
export const OfferProducts = styled.div`
  margin-top: 10px;
  span {
    color: rgba(0, 0, 0, 0.87);
    font-family: Montserrat;
    font-size: 12px;

    font-weight: 400;
  }
  p {
    color: rgba(0, 0, 0, 0.6);
    font-family: Montserrat;
    font-size: 12px;

    font-weight: 400;
  }
`;

export const CopyButtonDashed = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;

  span {
    border-radius: 4px 0px 0px 4px;
    border: 1px dashed #dadada;
    background: #fff;
    font-size: 12px;
    padding: 5px;
    display: block;
    flex-basis: 40%;
    text-align: center;
    @media (min-width: 768px) {
      flex-basis: 50%;
    }
  }
  button {
    border-radius: 0px 4px 4px 0px;
    border: 1px solid #ef4e5e;
    background: #ef4e5e;
    font-family: Montserrat;
    outline: none;
    color: #fff;
    font-size: 12px;
    padding: 5px 16px;
    @media (min-width: 768px) {
      cursor: pointer;
    }
  }
  @media (min-width: 768px) {
    cursor: pointer;
  }
`;

export const CopyButtonDashedNew = styled.div`
  margin-top: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .codeContainer {
    display: flex;
    align-items: center;
    gap: 10px;

    div {
      color: rgba(0, 0, 0, 0.87);
      font-family: Montserrat;
      font-size: 13px;
      font-weight: 500;
    }

    span {
      font-weight: 600;
      border-radius: 8px;
      border: 1px dashed #12b1c2;
      background: #f4feff;
      font-size: 12px;
      padding: 5px 13px;
      display: block;
      flex-basis: 40%;
      text-align: center;
      @media (min-width: 768px) {
        flex-basis: 50%;
      }
    }
  }

  button {
    border: none;
    background: transparent;
    font-family: Montserrat;
    outline: none;
    padding: 5px 0px;
    text-transform: uppercase;
    font-family: Montserrat;
    font-size: 13px;
    font-weight: 600;
    color: #ef4e5e;

    @media (min-width: 768px) {
      cursor: pointer;
    }
  }
  @media (min-width: 768px) {
    cursor: pointer;
  }
`;
